import React, { useState } from "react";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import { useGetAdminDetailsQuery } from "../services/adminApi";
import { checkIsAdmin, checkIsDoctor, getUserPrefferedName } from "../auth";
import { useGetPhysicianDetailsQuery } from "../services/physicianApi";
import { pageRoutes } from "../constants/pageRoutes";

const Header = ({ title }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const isCheckAdmin = checkIsAdmin();
  const isCheckDoctor = checkIsDoctor();
  const preferredUsername = getUserPrefferedName();

  const { data: adminData, isLoading: isAdminLoading } =
    useGetAdminDetailsQuery(preferredUsername, {
      skip: !isCheckAdmin,
    });

  const { data: physicianData, isLoading: isDoctorLoading } =
    useGetPhysicianDetailsQuery(preferredUsername, {
      skip: !isCheckDoctor,
    });

  const user =
    isCheckAdmin && adminData
      ? adminData
      : isCheckDoctor && physicianData
      ? physicianData
      : null;

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.split(" ");
    return words
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      sessionStorage.removeItem("sessionData");
      navigate(pageRoutes.login, { replace: true });
    } catch (error) {
      //console.error("Error signing out:", error);
    }
  };

  return (
    <nav
      className="bg-white w-full mb-2 border border-gray-300 dark:border-zinc-600 shadow-[0_1px_2px_rgba(0,0,0,0.20)]
"
    >
      <div className="max-w-screen flex flex-wrap items-center justify-between mx-2 pr-8 pl-2 py-3">
        <div className="font-bold text-2xl text-blue-900">{title}</div>

        {/* User Dropdown */}
        <div className="relative flex items-center space-x-3">
          <div
            className="flex items-center space-x-5 cursor-pointer select-none"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            {isAdminLoading || isDoctorLoading ? (
              // Skeleton UI
              <>
                <div className="w-9 h-9 rounded-full bg-gray-300 animate-pulse" />
                <div className="flex flex-col space-y-1">
                  <div className="w-24 h-3 bg-gray-300 rounded animate-pulse" />
                  <div className="w-16 h-2 bg-gray-200 rounded animate-pulse" />
                </div>
              </>
            ) : (
              <>
                {user?.image ? (
                  <img
                    className="w-9 h-9 rounded-full object-cover"
                    src={user.image}
                    alt="User"
                  />
                ) : (
                  <div className="w-9 h-9 rounded-full flex items-center justify-center font-bold bg-gray-400 text-white">
                    {getInitials(`${user?.FirstName} ${user?.LastName}`)}
                  </div>
                )}

                <span className="font-medium leading-[18px] text-[#344054]">
                  {user?.FirstName} {user?.LastName}
                  <br />
                  <span className="text-xs text-[#9C9C9C] leading-none font-semibold rounded">
                    {user?.PhysicianID ? "Doctor" : "Admin"}
                  </span>
                </span>
              </>
            )}

            <svg
              className={`w-4 h-4 transition-transform ${
                isDropdownOpen ? "rotate-180" : ""
              }`}
              fill="#323232"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path d="M3 7L9.5 13L16 7H3Z" fill="#323232" />
            </svg>
          </div>

          {/* Dropdown Menu */}
          {isDropdownOpen && !isAdminLoading && !isDoctorLoading && (
            <div
              className="absolute right-0 top-12 w-32 bg-white shadow-lg rounded-md py-2 z-50 animate-fade-in-down"
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <button
                onClick={handleSignOut}
                className="w-full text-center px-4 py-2 hover:bg-gray-100 text-gray-700 text-sm"
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>

      <style>
        {`
          @keyframes fade-in-down {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-fade-in-down {
            animation: fade-in-down 0.2s ease-out;
          }
        `}
      </style>
    </nav>
  );
};

export default Header;
